import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Typography, Paper } from '@mui/material';
import useStyles from './styles';
export default function MonthSummary(_ref) {
  let _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.summaryWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.summaryBlock, " ").concat(classes.monthTitle)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, data.month), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, data.isMoveInMonth && t('resident_account.moved_in'), !data.isMoveInMonth &&
  // (data.isSummary ? t('general.summary') : t('general.today'))
  t('general.statement'))), data.startingBalance && /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.starting_balance')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, data.startingBalance)), data.balanceOnFirst && /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.balance_on_the_first')), data.isSummary && /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, data.balanceOnFirst), !data.isSummary && !data.isMoveInMonth && /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, data.balanceOnFirst)), data.monthlyCharges && /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.month_charges', {
    month: data.month
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    color: "dark"
  }, data.monthlyCharges)), data.paymentsAndCredits && /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.payments')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    color: "success"
  }, data.paymentsAndCredits)), data.currentBalance && /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, !data.isEndOfPeriod ? 'End of period' : t('resident_account.current_balance')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, data.currentBalance))));
}
MonthSummary.propTypes = {
  data: PropTypes.shape({
    month: PropTypes.string,
    isMoveInMonth: PropTypes.bool,
    isSummary: PropTypes.bool,
    balanceOnFirst: PropTypes.string,
    monthlyCharges: PropTypes.string,
    paymentsAndCredits: PropTypes.string,
    currentBalance: PropTypes.string,
    startingBalance: PropTypes.string,
    isEndOfPeriod: PropTypes.bool
  })
};